/* Product gallery and lightbox. */
(function () {
function initProductLightbox() {
  if (!window.jQuery || !window.jQuery.fancybox) return;
  window.CWGalleryZoom = function (element, step) {
    var control = element.closest('.cw-gallery-zoom');
    if (!control) return false;
    var range = control.querySelector('input[type="range"]');
    applyGalleryZoom(control, typeof step === 'number' ? Number(range.value) + step : range.value);
    return false;
  };
  var links = window.jQuery('.product-gallery-lightbox');
  if (!links.length || links.data('cwLightbox')) return;
  function applyGalleryZoom(control, nextValue) {
    dismissGalleryHint(control.closest('.cw-product-lightbox'));
    var range = control.querySelector('input[type="range"]');
    var value = control.querySelector('output');
    var zoom = Math.max(0, Math.min(100, Number(nextValue) || 0));
    range.value = zoom;
    value.textContent = zoom + '%';
    var image = control.closest('.cw-product-lightbox').querySelector('.fancybox-slide--current .fancybox-image');
    if (image) {
      var nativeScale = Math.max(1, Math.min(image.naturalWidth / image.offsetWidth, image.naturalHeight / image.offsetHeight));
      image.dataset.cwZoomScale = String(1 + ((nativeScale - 1) * (zoom / 100)));
      if (zoom === 0) { image.dataset.cwPanX = '0'; image.dataset.cwPanY = '0'; }
      renderGalleryImage(image);
    }
  }
  function renderGalleryImage(image) {
    var slide = image.closest('.fancybox-slide--current');
    if (!slide) return;
    var scale = Number(image.dataset.cwZoomScale) || 1;
    var maxX = Math.max(0, ((image.offsetWidth * scale) - slide.clientWidth) / 2);
    var maxY = Math.max(0, ((image.offsetHeight * scale) - slide.clientHeight) / 2);
    var panX = Math.max(-maxX, Math.min(maxX, Number(image.dataset.cwPanX) || 0));
    var panY = Math.max(-maxY, Math.min(maxY, Number(image.dataset.cwPanY) || 0));
    image.dataset.cwPanX = String(panX); image.dataset.cwPanY = String(panY);
    image.style.transformOrigin = 'center center';
    image.style.transition = image.dataset.cwDragging === 'true' ? 'none' : 'transform .18s ease-out';
    image.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
    image.style.cursor = scale > 1 ? 'grab' : 'default';
  }
  function dismissGalleryHint(container) {
    var hint = container.querySelector('.cw-gallery-zoom-hint');
    var control = container.querySelector('.cw-gallery-zoom');
    if (!hint || hint.classList.contains('is-leaving')) return;
    hint.classList.add('is-leaving');
    if (control) control.classList.remove('cw-gallery-zoom--guided');
    window.setTimeout(function () { hint.remove(); }, 360);
  }
  if (!document.__cwGalleryZoomControlsWired) {
    document.__cwGalleryZoomControlsWired = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('.cw-gallery-zoom button');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var control = button.closest('.cw-gallery-zoom');
      var range = control.querySelector('input[type="range"]');
      applyGalleryZoom(control, Number(range.value) + (button.hasAttribute('data-cw-zoom-plus') ? 10 : -10));
    }, true);
    document.addEventListener('input', function (event) {
      if (!event.target.matches('.cw-gallery-zoom input[type="range"]')) return;
      event.stopImmediatePropagation();
      applyGalleryZoom(event.target.closest('.cw-gallery-zoom'), event.target.value);
    }, true);
  }
  function wireGalleryPanning(container) {
    if (window.innerWidth <= 767) return;
    var slide = container.querySelector('.fancybox-slide--current');
    if (!slide || slide.dataset.cwPanReady) return;
    slide.dataset.cwPanReady = 'true';
    var drag = null;
    slide.addEventListener('pointerdown', function (event) {
      if (event.target.closest('.cw-gallery-zoom, .fancybox-thumbs, .fancybox-toolbar')) return;
      var image = slide.querySelector('.fancybox-image');
      if (!image || (Number(image.dataset.cwZoomScale) || 1) <= 1) return;
      drag = { image: image, x: event.clientX, y: event.clientY, panX: Number(image.dataset.cwPanX) || 0, panY: Number(image.dataset.cwPanY) || 0 };
      dismissGalleryHint(container);
      image.dataset.cwDragging = 'true';
      image.style.cursor = 'grabbing';
      slide.setPointerCapture(event.pointerId);
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    slide.addEventListener('pointermove', function (event) {
      if (!drag) return;
      drag.image.dataset.cwPanX = String(drag.panX + event.clientX - drag.x);
      drag.image.dataset.cwPanY = String(drag.panY + event.clientY - drag.y);
      renderGalleryImage(drag.image);
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    ['pointerup', 'pointercancel'].forEach(function (eventName) {
      slide.addEventListener(eventName, function (event) {
        if (!drag) return;
        drag.image.dataset.cwDragging = 'false';
        renderGalleryImage(drag.image);
        drag = null;
        event.stopImmediatePropagation();
      }, true);
    });
  }
  function addZoomControl(instance) {
    var container = instance && instance.$refs && instance.$refs.container && instance.$refs.container[0];
    if (!container) return;
    var control = container.querySelector('.cw-gallery-zoom');
    if (!control) {
      control = document.createElement('div');
      control.className = 'cw-gallery-zoom';
      control.setAttribute('aria-label', 'Image zoom');
      control.innerHTML = '<button type="button" data-cw-zoom-plus aria-label="Zoom in" onclick="return window.CWGalleryZoom(this,10)">+</button>' +
        '<input type="range" min="0" max="100" step="5" value="0" aria-label="Zoom level" oninput="window.CWGalleryZoom(this)">' +
        '<button type="button" data-cw-zoom-minus aria-label="Zoom out" onclick="return window.CWGalleryZoom(this,-10)">−</button>' +
        '<output class="cw-gallery-zoom__value">100%</output>';
      (container.querySelector('.fancybox-toolbar') || container).appendChild(control);
      ['pointerdown', 'click', 'dblclick'].forEach(function (eventName) {
        control.addEventListener(eventName, function (event) { event.stopPropagation(); });
      });
      control._cwApplyZoom = function (nextValue) { applyGalleryZoom(control, nextValue); };
      var hint = document.createElement('aside');
      hint.className = 'cw-gallery-zoom-hint';
      hint.innerHTML = '<strong>Zoom &amp; pan</strong>Use the slider to zoom, then drag the image to explore.';
      (container.querySelector('.fancybox-toolbar') || container).appendChild(hint);
      control.classList.add('cw-gallery-zoom--guided');
      window.setTimeout(function () { dismissGalleryHint(container); }, 6200);
    }
    wireGalleryPanning(container);
  }
  links.data('cwLightbox', true).fancybox({
    baseClass: 'cw-product-lightbox',
    buttons: ['close'],
    loop: true,
    clickContent: false,
    touch: { vertical: true, momentum: true },
    thumbs: { autoStart: window.innerWidth > 575, axis: 'y' },
    afterShow: function (instance) { addZoomControl(instance); }
  });
}

  function init() { initProductLightbox(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
